//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {
      isActive: false,
    }
  },
  props: {
    postId: {
      type: Number
    }
  },
  mounted: function() {
    if(localStorage.getItem('favourites_ids') !== null) {
        if(JSON.parse(localStorage.getItem('favourites_ids')).includes(this.postId)) {
          this.isActive = true
        }
    }
  },
  methods: {
    toggleFavourite: function () {
      let _this = this
      this.isActive = !this.isActive
      let favourites_ids = [];
      if(localStorage.getItem('favourites_ids') !== null)
          favourites_ids = JSON.parse(localStorage.getItem('favourites_ids'))

      if (this.isActive) {
        favourites_ids.push(this.postId)
        localStorage.setItem('favourites_ids', JSON.stringify(favourites_ids)); 
      }
      else {
        favourites_ids = favourites_ids.filter(function(item) {
          return item !== _this.postId
        })
        localStorage.setItem('favourites_ids', JSON.stringify(favourites_ids))
      }

      this.$emit('click:addtofavourites', { 'id': this.postId, 'isActive': this.isActive });

    }
  },
  computed: {
    favouritesText: function () {
      if (this.isActive)
        return 'Added'

      return 'Add'
    },
  }
}



// WEBPACK FOOTER //
// ./scripts/vue/ButtonFavourites.vue